import { ComponentProps } from "react";
import { ThemeProvider } from "@emotion/react";
import { theme } from "styles/theme";

export function MixThemeProvider(
  props: Omit<ComponentProps<typeof ThemeProvider>, "theme">,
) {
  return <ThemeProvider theme={theme} {...props} />;
}
